import React from 'react';
import AdicionarDocumentoDialog from '../../../components/documentos/AdicionarDocumentoDialog';

export default function AdicionarPolitica(props) {
    return (
        <AdicionarDocumentoDialog
            open={props.adicionarPolitica}
            onClose={() => props.setAdicionarPolitica(false)}
            endpoint="adicionarPolitica"
            title="Nova versão da Política de Privacidade"
            description="O conteúdo publicado passa a valer como a versão mais recente da política."
            placeholder="Digite a política de privacidade aqui..."
        />
    );
}
